module.exports = __webpack_public_path__ + "img/applemusic.f7d75a78.png";